module.exports = __webpack_public_path__ + "img/hsl.ab985c68.jpeg";